import MassDownload from "../components/SubmissionsList/ActionToolbar/MassDownload/MassDownload";
import PreviewDeliverables from "../components/SubmissionsList/ActionToolbar/PreviewDeliverables/PreviewDeliverables";
import { Action, CustomTagType, DockType, ErrorCodes, OperationType, Position, WarningType, WindowType } from "puzzle";
import SourceFilesDialog from "../components/SubmissionsList/ActionToolbar/SourceFiles/SourceFilesDialog";
import ClaimDialog from "../components/SubmissionsList/ActionToolbar/Claim/ClaimDialog";
import ClaimInstructions from "../components/SubmissionsList/ActionToolbar/Claim/Instructions/ClaimInstructions";
import UploadDialog from "../components/SubmissionsList/ActionToolbar/UploadDialog/UploadDialog";

export const assign_submission_vendor: Action = [{
  name: 'selectSuppliers',
  type: OperationType.action
}];

export const removePersistentActionData: Action = [{
  persistent: ['actionData'],
  type: OperationType.removePersistentData
}];

export const setActionToolbarConfig: Action = [{
  moduleName: 'ActionToolbar',
  name: 'prepareActionsData',
  args: ['actionData'],
  type: OperationType.addOperationData
}];

export const delete_submission_system: Action = [{
  data: {
    template: {
      bind: {
        submissionId: '{submissionData.submissionId}'
      }
    }
  },
  persistent: ['submissionId'],
  type: OperationType.addPersistentData
}, {
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      persistent: ['submissionId'],
      type: OperationType.removePersistentData
    }],
    btnName: 'deleteSubmission.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'App',
      type: OperationType.maskModule
    }, {
      data: {
        template: {
          method: 'delete',
          bind: {
            url: '"/submissions/" + {submissionId}',
          }
        }
      },
      type: OperationType.request
    }, {
      persistent: ['submissionId'],
      type: OperationType.removePersistentData
    }, {
      name: 'refreshMainGridOnCurrentPosition',
      type: OperationType.action
    }, {
      name: 'closeDrawer',
      type: OperationType.action
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    btnName: 'deleteSubmission.yes',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error'
    }
  }],
  className: 'sm confirm-light',
  text: 'deleteSubmission.text',
  title: 'deleteSubmission.title',
  type: OperationType.warning
}];

export const mass_download: Action = [{
//   data: {
//     isRest: false,
//     url: `/massDownload/phases`
//   },
//   mappingName: 'phasesData',
//   type: OperationType.request
// }, {
  className: 'sm mass-download',
  children: [{
    render: MassDownload
  }],
  items: [{
    operations: [{
      data: {
        template: {
          method: 'post',
          bind: {
            url: '"/submissions/" + {selectedSubmissions[0].submissionId} + "/download"',
          },
          params: {
            sourceFiles: true
          }
        }
      },
      mappingName: 'downloadData',
      type: OperationType.request,
    }, {
      name: 'pingUntilDownloadIsReady',
      type: OperationType.action
    }],
    btnName: 'massDownload.download',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  title: 'massDownload.title',
  type: OperationType.dialog
// }, {
//   moduleName: 'MassDownload',
//   name: 'loadPhases',
//   args: ['phasesData', 'selectedSubmissions'],
//   type: OperationType.addOperationData
}];

export const download_submission_source_files: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  name: 'pingUntilDownloadIsReady',
  type: OperationType.action
}];

export const source_files: Action = [{
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{submissionName}',
      }
    }
  },
  persistent: ['submissionName'],
  type: OperationType.data
}, {
  data: {
    template: {
      asSubId: true,
      bind: {
        submissionId: '{submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    labelTextAll: 'downloadSource.downloadAll',
    labelTextSelected: 'downloadSource.downloadSelected',
    buttonActionNameAll: 'downloadAllButtonAction',
    buttonActionNameSelected: 'download_submission_source_files'
  },
  title: 'sourceFilesDialog.title',
  children: [{
    render: SourceFilesDialog
  }],
  className: 'lg download-source-files with-custom-header',
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'sourceFilesDialog.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'downloadSelected',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end,
      args: ['labelTextSelected', 'selectedFiles', 'buttonActionNameSelected'],
      customTagType: CustomTagType.buttonCounter,
    },
  }, {
    btnName: 'downloadAll',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end,
      args: ['labelTextAll', 'total', 'buttonActionNameAll'],
      customTagType: CustomTagType.buttonCounter,
    },
  }],
  type: OperationType.dialog
}, {
  moduleName: 'SourceFilesDialog',
  name: 'getPageSize',
  mappingName: 'pageSize',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      params: {
        bind: {
          pageSize: '{pageSize}'
        },
        orderBy: 'name'
      }
    }
  },
  name: 'getSourceFilesRequest',
  type: OperationType.action
}, {
  data: {
    selectedFiles: 0,
    template: {
      bind: {
        total: '{gridData.gridContentInfo.totalCount}'
      }
    }
  },
  name: 'updateDownloadSourceFilesButtons',
  type: OperationType.action,
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const getSourceFilesRequest: Action = [{
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/" + {selectedSubmissions[0].submissionId} + "/documents"',
        params: '{params}'
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'gridData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{gridData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'SourceFilesDialog',
  args: ['gridData'],
  name: 'setGridData'
}, {
  moduleName: 'SourceFilesDialog',
  name: 'getSelectedData',
  mappingName: 'selectedRecords',
  type: OperationType.addOperationData,
}, {
  data: {
    template: {
      bind: {
        selectedFiles: '{selectedRecords}',
        total: '{gridData.gridContentInfo.totalCount}'
      }
    }
  },
  name: 'updateDownloadSourceFilesButtons',
  type: OperationType.action,
}];

export const getNextPageData: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'getSourceFilesRequest',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const getSourceFilesWithFilter: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  moduleName: 'SourceFilesDialog',
  name: 'resetGridData'
}, {
  name: 'getSourceFilesRequest',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const preview_translation: Action = [{
  data: {
    filesCount: 0,
    selectedFilesTranslated: 'previewDeliverables.selectedFilesInfo',
    notificationText: 'previewDeliverables.footerNotificationText',
    notificationType: 'warning',
    notificationIcon: 'error',
    template: {
      asSubName: true,
      asSubId: true,
      bind: {
        submissionName: '{submissionName}',
        submissionId: '{params.submissionIds}'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    method: 'get',
    url: `/submissions/previewDeliverable`,
    template: {
      bind: {
        params: '{params}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'previewDeliverablesGetResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{previewDeliverablesGetResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  children: [{
    render: PreviewDeliverables
  }],
  className: 'xl preview-deliverables with-custom-header',
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    operations: [],
    btnName: 'previewDeliverables.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [],
    btnName: 'previewDeliverables.notificationLabel',
    btnConfig: {
      pos: Position.start,
      args: ['selectedFilesTranslated', 'filesCount'],
      customTagType: CustomTagType.counter
    }
  }, {
    btnName: 'previewDeliverables.disclaimer',
    btnConfig: {
      pos: Position.start,
      args: ['notificationText', 'notificationType', 'notificationIcon'],
      customTagType: CustomTagType.notificationLabel,
      hidden: true
    }
  }, {
    operations: [{
      moduleName: 'PreviewDeliverables',
      name: 'getJsonForPost',
      mappingName: 'jsonForPost',
      type: OperationType.addOperationData
    }, {
      condition: '!_.isEmpty({jsonForPost})',
      conditionOperations: [{
        // TODO PDII-26332
        // New UI | Wrong pinging url at previewDeliverables
        data: {
          template: {
            method: 'post',
            url: '/submissions/previewDeliverable',
            bind: {
              params: '{jsonForPost}'
            }
          }
        },
        handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
        mappingName: 'downloadData',
        type: OperationType.request
      }, {
        data: {
          template: {
            bind: {
              responseData: '{downloadData}',
            }
          }
        },
        name: 'handleRequestException',
        type: OperationType.action
      }, {
        data: {
          template: {
            params: {
              bind: {
                downloadId: '{downloadData.downloadId}'
              }
            }
          }
        },
        name: 'pingUntilDownloadIsReady',
        type: OperationType.action
      }, {
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }],
      type: OperationType.conditional
    }],
    btnName: 'previewDeliverables.downloadBtn',
    close: false,
    btnConfig: {
      accessibility: {
        ariaLabel: '',
        iconAriaHidden: true
      },
      disabled: true,
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  title: 'previewDeliverables.title',
  type: OperationType.dialog
}, {
  moduleName: 'PreviewDeliverables',
  name: 'loadSubmissions',
  args: ['previewDeliverablesGetResponse'],
}];

export const setSubmissionByLanguage: Action = [{
  data: {
    activeTabToogler: true
  },
  moduleName: 'PreviewDeliverables',
  name: 'setLanguagesTabActive',
  args: ['activeTabToogler']
}]

export const setSubmissionByBatch: Action = [{
  data: {
    activeTabToogler: false
  },
  moduleName: 'PreviewDeliverables',
  name: 'setLanguagesTabActive',
  args: ['activeTabToogler']
}]

export const updatePreviewDeliverablesFooter: Action = [{
  data: {
    notificationText: 'previewDeliverables.footerNotificationText',
    notificationType: 'warning',
    notificationIcon: 'error',
    selectedFilesTranslated: 'previewDeliverables.selectedFilesInfo'
  },
  type: OperationType.data
}, {
  buttons: [{
    name: 'previewDeliverables.downloadBtn',
    disabled: '!{filesCount}'
  }],
  customTags: [{
    name: 'previewDeliverables.notificationLabel',
    args: ['selectedFilesTranslated', 'filesCount'],
  }, {
    name: 'previewDeliverables.disclaimer',
    args: ['notificationText', 'notificationType', 'notificationIcon'],
    hidden: '!{filesCount}'
  }],
  type: OperationType.updateDialog
}];

export const downloadResources: Action = [{
  data: {
    template: {
      downloadType: 'blob',
      isDownload: true,
      method: 'post',
      url: '/resources/download',
      bind: {
        params: '{params}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'responseData',
  type: OperationType.request,
}, {
  name: 'handleRequestException',
  type: OperationType.action
}];

export const pingUntilDownloadIsReady: Action = [{
  name: 'downloadToaster',
  type: OperationType.action
}, {
  name: 'pingUntilDownloadIsReadyDownloadAction',
  type: OperationType.action
}];

export const downloadToaster: Action = [{
  data: {
    template: {
      bind: {
        toasterModuleId: '{toasterModuleId} || "ToastNotificationsViewport"'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId}',
  name: 'createDownloadNotification'
}]

export const createToaster: Action = [{
  data: {
    template: {
      bind: {
        toasterModuleId: '{toasterModuleId} || "ToastNotificationsViewport"'
      }
    }
  },
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId}',
  args: ['toasterText', 'toasterType'],
  name: 'createToaster'
}];

// @ts-ignore
export const pingUntilDownloadIsReadyDownloadAction: Action = [{
  ping: {
    template: {
      method: 'post',
      bind: {
        url: '"/submissions/" + ({submissionId} ? {submissionId} : {selectedSubmissions[0].submissionId}) + "/download"'
      }
    }
  },
  pingBreakCondition: ['errors'],
  pingCondition: 'processingFinished',
  delay: 1000,
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  pingErrorOperations: [{
    data: {
      template: {
        bind: {
          endpointPrefix: '{errorHandlerPrefix} || "DOWNLOAD_"',
        },
        responseData: {
          response: {
            bind: {
              data: '{pingResponseDownloadData}',
              status: '{responseStatus}'
            }
          }
        }
      }
    },
    type: OperationType.data
  }, {
    condition: '_.get({responseData}, "response.data.errors[0].errorCode") === "REST.ERR.ACTION.FILENOTCLAIM"',
    conditionOperations: [{
      items: ['all'],
      type: OperationType.syncDispatchersDataItem
    }, {
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      name: "claimNotClaimedFilesWarning",
      type: OperationType.action
    }],
    elseOperations: [{
      name: 'handleRequestException',
      type: OperationType.action
    }],
    type: OperationType.conditional
  },],
  mappingName: 'pingResponseDownloadData',
  download: {
    template: {
      method: 'get',
      bind: {
        url: "'/submissions/download/' + {pingResponseDownloadData.downloadId}",
      }
    }
  },
  afterDownloadOperations: [{
    name: 'afterDownloadOperations',
    type: OperationType.action
  }],
  withIndicator: false,
  pingOperations: [],
  type: OperationType.pingDownload
}];

export const afterDownloadOperations: Action = [{
  condition: '{additionalData} && {additionalData.afterDownloadOperation}',
  conditionOperations: [{
    evaluate: true,
    name: '{additionalData.afterDownloadOperation}',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const downloadResource: Action = [{
  condition: '{downloadData.processingFinished}',
  conditionOperations: [{
    condition: '{downloadData.message} === null',
    conditionOperations: [{
      data: {
        template: {
          isDownload: true,
          method: 'get',
          bind: {
            url: "'/submissions/download/' + {downloadData.downloadId}",
          }
        }
      },
      mappingName: 'downloadData',
      type: OperationType.request
    }],
    elseOperations: [], // TODO raise error
    type: OperationType.conditional
  }],
  elseOperations: [{
    actionType: {
      dispatcherId: 'AsyncDownloadDispatcher',
      delay: 1000
    },
    data: {
      template: {
        bind: {
          selectedSubmissions: '{selectedSubmissions}'
        },
        params: {
          bind: {
            downloadId: '{downloadData.downloadId}'
          }
        }
      }
    },
    name: 'pingForDownloadResource',
    type: OperationType.stack
  }],
  type: OperationType.conditional
}];

export const cancel_nui: Action = [{
  name: 'cancelSubmission',
  type: OperationType.action
}];

export const pingForDownloadResource: Action = [{
  data: {
    template: {
      method: 'post',
      bind: {
        url: '"/submissions/" + ({submissionId} ? {submissionId} : {selectedSubmissions[0].submissionId})+ "/download"',
        params: '{params}'
      }
    }
  },
  mappingName: 'downloadData',
  type: OperationType.request,
}, {
  items: ['downloadData', 'selectedSubmissions'],
  type: OperationType.syncDispatchersDataItem
}, {
  name: 'downloadResource',
  type: OperationType.action
}];

export const manual_edit_submission: Action = [{
  data: {
    submissionMode: 'EDIT'
  },
  type: OperationType.data
}, {
  name: 'editSubmission',
  type: OperationType.action
}];

export const start_submission: Action = [{
  name: 'startSubmissionRequest',
  type: OperationType.action
}];

export const selectedSubmissionIsRequired: Action = [{
  className: 'sm info footer-centered',
  warningType: WarningType.info,
  text: 'oneSelectionRecordRequiredText',
  title: 'oneSelectionRecordRequiredTitle',
  type: OperationType.warning,
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'batchUpload.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }]
}];

export const manual_clone_submission: Action = [{
  name: 'cloneSubmissionRequest',
  type: OperationType.action
}];

export const analyze_submission: Action = [{
  data: {
    template: {
      bind: {
        url: '"/submissions/" + {submissionData.submissionId} + "/analyze"',
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'analyzeResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{analyzeResponse}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'refreshApp',
  type: OperationType.action
}];

export const claim: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/submissions/"+ {submissionData.submissionId}+"/claim"'
      }
    }
  },
  mappingName: 'getClaimDataResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{getClaimDataResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/submissions/"+ {submissionData.submissionId}+"/instructions"'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'getInstructionsRequestData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{getInstructionsRequestData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{submissionData.submissionName}',
        submissionId: '{submissionData.submissionId}',
        getInstructionsData: '{getInstructionsRequestData}'
      }
    }
  },
  type: OperationType.data
}, {
  title: 'claimDialog.title',
  children: [{
    render: ClaimDialog,
    propArgs: ['submissionData']
  }],
  className: 'xl with-custom-header claim-phases',
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'claimDialog.cancel',
    close: false,
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      name: 'exitClaim',
      type: OperationType.action
    }]
  }, {
    btnName: 'claimDialog.previewInstructions',
    close: false,
    operations: [{
      name: 'previewInstructions',
      type: OperationType.action
    }],
    btnConfig: {
      accessibility: {
        ariaLabel: '',
        iconAriaHidden: true
      },
      hidden: true,
      themeColor: 'primary',
      fillMode: "flat",
      iconClass: 'tp-icon tp-info',
      pos: Position.start
    }
  }, {
    btnName: 'claimDialog.claimPhases',
    btnConfig: {
      themeColor: 'primary',
      disabled: true,
      pos: Position.end
    },
    close: false,
    operations: [{
      moduleName: 'ClaimDialog',
      name: 'proceedWithClaim',
      type: OperationType.addOperationData
    }, {
      data: {
        template: {
          notificationData: {
            notificationCase: 'claim',
            bind: {
              taskPhaseLength: '{proceedWithClaim.items}'
            }
          },
          bind: {
            claimParams: '{proceedWithClaim.params}'
          }
        }
      },
      type: OperationType.data
    }, {
      persistent: ['claimParams', 'notificationData'],
      type: OperationType.addPersistentData
    }, {
      name: 'claimPM',
      type: OperationType.action
    }]
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      name: 'exitClaim',
      type: OperationType.action
    }]
  }],
  type: OperationType.dialog
}, {
  moduleName: 'ClaimDialog',
  name: 'setData',
  args: ['getClaimDataResponse', 'getInstructionsData']
}, {
  name: 'updateClaimInstructions',
  type: OperationType.action
}];

export const claimPM: Action = [{
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: '"/submissions/"+{selectedSubmissions[0].submissionId}+"/claim"',
        params: '{claimParams}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  persistent: ['claimParams'],
  type: OperationType.removePersistentData
}, {
  data: {
    template: {
      bind: {
        url: '"/submissions/"+{selectedSubmissions[0].submissionId}+"/claim"'
      },
      afterPingFinishAction: 'afterClaimPMCompletion',
      method: 'post'
    }
  },
  type: OperationType.data
}, {
  name: 'pingingRequest',
  type: OperationType.action
}]

export const afterClaimPMCompletion: Action = [{
  name: 'refreshApp',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}, {
  moduleName: 'ToastNotifications',
  args: ['notificationData'],
  name: 'createClaimNotifications'
}, {
  persistent: ['notificationData'],
  type: OperationType.removePersistentData
}]

export const exitClaim: Action = [{
  moduleName: 'ClaimDialog',
  name: 'checkForSelectedData',
  mappingName: 'selectionExists',
  type: OperationType.addOperationData
}, {
  condition: '{selectionExists}',
  conditionOperations: [{
    name: 'exitClaimConfirmation',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'closeClaimDialog',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const exitClaimConfirmation: Action = [{
  warningType: WarningType.info,
  title: 'exitClaimConfirmation.title',
  text: 'exitClaimConfirmation.message',
  className: 'sm confirm-light',
  type: OperationType.warning,
  items: [{
    btnName: 'exitClaimConfirmation.no',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'exitClaimConfirmation.yes',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error'
    },
    operations: [{
      name: 'closeClaimDialog',
      type: OperationType.action
    }]
  }]
}];

export const closeClaimDialog: Action = [{
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}];

export const previewInstructions: Action = [{
  moduleName: 'ClaimDialog',
  name: 'getInstructionsData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{selectedSubmissions[0].submissionName}',
        submissionId: '{selectedSubmissions[0].submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  title: 'claimDialog.instructions',
  children: [{
    render: ClaimInstructions,
    propArgs: ['getInstructionsData']
  }],
  waitForModule: true,
  className: 'md preview-instructions with-custom-header',
  closable: true,
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'claimDialog.backToClaim',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.start
    },
    operations: []
  }],
  type: OperationType.dialog
}];

export const updateClaimFooter: Action = [{
  buttons: [{
    name: 'claimDialog.claimPhases',
    disabled: '!{existingSelection}'
  }, {
    name: 'claimDialog.previewInstructions',
    hidden: '!{instructions}'
  }],
  type: OperationType.updateDialog
}];

export const updateClaimInstructions: Action = [{
  buttons: [{
    name: 'claimDialog.previewInstructions',
    hidden: '!{getInstructionsData.instructions}'
  }],
  type: OperationType.updateDialog
}];

export const rest_upload: Action = [{
  data: {
    template: {
      completeActionName: 'reportDialogCompleteAll',
      returnActionName: 'reportDialogReturnAll',
      downloadReportUrl: '/submissions/download/upload/report',
      bind: {
        uploadDialogUrl: "'/submissions/' + {selectedSubmissions[0].submissionId} + '/upload'",
        uploadReportGetUrl: "'/submissions/' + {selectedSubmissions[0].submissionId} +'/upload/report/'"
      }
    }
  },
  persistent: ['uploadDialogUrl', 'uploadReportGetUrl', 'downloadReportUrl', 'completeActionName', 'returnActionName'],
  type: OperationType.addPersistentData
}, {
  name: 'openUploadDialog',
  type: OperationType.action
}];

export const openUploadDialog: Action = [{
  persistent: [
    'completeActionName',
    'downloadReportUrl',
    'reopenDialogFlow',
    'returnActionName',
    'uploadDialogUrl',
    'uploadReportGetUrl'
  ],
  type: OperationType.addPersistentData
}, {
  condition: '{submissionData}',
  conditionOperations: [{
    data: {
      template: {
        asSubName: true,
        bind: {
          submissionName: '{submissionData.submissionName}'
        }
      }
    },
    persistent: ['submissionName'],
    type: OperationType.data
  }, {
    data: {
      template: {
        asSubId: true,
        bind: {
          submissionId: '{submissionData.submissionId}'
        }
      }
    },
    persistent: ['submissionId'],
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  children: [{
    render: UploadDialog,
    propArgs: ['files', 'supplierView', 'submissionData']
  }],
  className: 'xl upload',
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'uploadDialog.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      condition: '{reopenDialogFlow}',
      conditionOperations: [{
        dispatcherIds: ['batchPingDispatcher'],
        type: OperationType.stopAll
      }, {
        name: 'refreshApp',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }]
  }],
  title: 'uploadDialog.title',
  type: OperationType.dialog
}, {
  condition: '{droppedFiles} && {droppedFiles.length}',
  conditionOperations: [{
    waitForModule: true,
    moduleName: 'UploadDialog',
    name: 'startFileUpload',
    args: ['droppedFiles']
  }],
  type: OperationType.conditional
}, {
  name: 'removePersistentUploadData',
  type: OperationType.action
}];

export const removePersistentUploadData: Action = [{
  persistent: ['files'],
  type: OperationType.removePersistentData
}];

export const setCheckboxSelected: Action = [{
  condition: '{forceDrawerClose}',
  conditionOperations: [{
    name: 'closeDrawer',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  args: ['selectedItems'],
  moduleName: 'ActionToolbar',
  name: 'setCheckboxSelected'
}, {
  args: ['selectedItems'],
  moduleName: 'ContextMenu',
  name: 'setCheckboxSelected'
}];

export const ToastNotificationsPuzzle: Action = [{
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: `{toasterModuleId} || "ToastNotificationsPuzzle"`,
  name: 'addNotification',
  args: ['notificationData']
}];

export const copy_URI: Action = [{
  name: 'copyToClipboardBtnAction',
  delay: 100,
  synchronous: true,
  args: ['urlToCopy'],
  moduleName: 'ActionExecutor'
}, {
  data: {
    template: {
      notificationData: {
        icon: 'check',
        isClosable: false,
        notificationTextParams: {
          locale: 'copyURI',
          moduleName: 'ToastNotifications',
        },
        position: 'middle',
        size: 'small',
        type: 'dark'
      }
    }
  },
  name: 'ToastNotificationsPuzzle',
  type: OperationType.action
}]
